import { render, staticRenderFns } from "./cell-promo-code-name.vue?vue&type=template&id=b4ec1794&scoped=true"
import script from "./cell-promo-code-name.ts?vue&type=script&lang=ts&external"
export * from "./cell-promo-code-name.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-promo-code-name.vue?vue&type=style&index=0&id=b4ec1794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ec1794",
  null
  
)

export default component.exports